
import { AdminTemplate, MerchantPOSUsageFeeComponent } from "../../components";

export const MerchantPOSUsageFee = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "Üye İşyeri POS Kullanım Bedeli",
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
            showHeaderTitle={true}>
            <MerchantPOSUsageFeeComponent />
        </AdminTemplate>
    );
};
